<template>
  <div :class="`layout-box ${safeBottomAreaClass}`">
    <RouterView v-if="initReady" v-slot="{ Component }">
      <template v-if="Component">
        <KeepAlive :include="keepAliveComponents">
          <component :is="Component" :key="route.meta.routerViewKey ?? route.fullPath" />
        </KeepAlive>
      </template>
    </RouterView>
  </div>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router';
  import { useInitService, useKeepAliveComponents } from '@shared/hooks';

  import { isNeedSafeBottomArea } from '@shared/utils';
  const route = useRoute();
  // 底部安全样式名, 可以通过meta标签控制隐藏
  const safeBottomAreaClass = !route.meta.customSafeBottomArea && isNeedSafeBottomArea ? 'safe-bottom-area' : '';

  // 页面初始化
  const { isReady: initReady } = useInitService();

  // 加载 keepAlive 组件
  const { keepAliveComponents } = useKeepAliveComponents();
</script>

<style lang="less" scoped></style>
